import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  output,
  computed,
} from '@angular/core';
import {
  ControlContainer,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TrimDirective } from '../../directives/trim/trim.directive';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'lib-textarea',
  imports: [ReactiveFormsModule, TrimDirective],
  templateUrl: './textarea.component.html',
  styleUrl: './textarea.component.scss',
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: () => inject(ControlContainer, { skipSelf: true }),
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TextareaComponent implements OnInit {
  inputFormControlName = input.required<string>();
  id = input.required<string>();
  name = input.required<string>();

  label = input<string>();
  placeholder = input<string>('');
  inputClass = input<string>('');
  width = input<string>('42.3125rem');
  height = input<string>('6.5rem');

  startIcon = input<string>();
  endIcon = input<string>();

  minlength = input<number>();
  maxlength = input<number>();
  rowsNumber = input<string>('4');

  disabled = input<boolean>(false);
  readonly = input<boolean>();
  value = input<string | number>();
  required = input<boolean>(false);
  resize = input<boolean>(false);

  endIconCLick = output<void>();
  typing = output<string>();

  displayPlaceholder = computed(() => {
    const providedPlaceholder = this.placeholder();
    if (providedPlaceholder) {
      return providedPlaceholder;
    }
    return this.transloco.translate('textarea_default_placeholder');
  });

  private readonly parentContainer = inject(ControlContainer);
  private readonly transloco = inject(TranslocoService);

  private get parentFormGroup() {
    return this.parentContainer.control as FormGroup;
  }

  protected get childControl() {
    return this.parentFormGroup?.controls[
      this.inputFormControlName()
    ] as FormControl;
  }

  ngOnInit(): void {
    if (this.disabled()) {
      this.childControl.disable();
    }
    if (this.required()) {
      this.childControl.addValidators(Validators.required);
    }
  }

  applyActionOnEndIconClicked() {
    this.endIconCLick.emit();
  }
}
